module.exports = __webpack_public_path__ + "static/img/btn.551eb421.png";